export const getCity = (text: string): string => {
    return text.replace(/[0-9]/gi, '').trim();
};

export const getPostalCode = (text: string): string => {
    return text.replace(/\D/g, '');
};

export const formatPostalCodeInput = (postalCode: string, city: string) => `${postalCode} ${city}`;

export const getPostalCodeFirst = (text: string) => {
    return formatPostalCodeInput(getPostalCode(text), getCity(text));
};
